import { actionTypes } from "./actions";

const initialState = {
    altAssets: {
        ids: [],
        summary: {
            pending: 0,
            resolved: 0,
            total: 0
        }
    },
    auditAssets: {
        ids: [],
        summary: {
            approved: 0,
            autoVerified: 0,
            pending: 0,
            excluded: 0,
            excludedPending: 0,
            seenPending: 0,
            // autoVerifiedPending: 0,
            reissued: 0,
            rejected: 0,
            unchecked: 0,
            total: 0,
            validated: 0
        },
        nonMandatoryTotal: 0,
    },
    validatedVisibility: {
        ids: [],
        summary: {
            approved: 0,
            // pending: 0,
            reissued: 0,
            rejected: 0,
            total: 0,
            validated: 0
        },
        approved: 0,
        // pending: 0,
        reissued: 0,
        rejected: 0,
        total: 0,
        validated: 0
    },
    status: ["expected"],
    isReissueNeeded: false,
    isReviewComplete: false
};

export default function (state = { ...initialState }, action) {
    switch (action.type) {
        case actionTypes.AUDIT_REVIEW_ALT_ASSETS_FILTER_SET: {
            const { filter, status } = action.payload;
            const { altAssets } = state;
            return { ...state, altAssets: { ...altAssets, ...filter }, status };
        }
        case actionTypes.AUDIT_REVIEW_ALT_ASSETS_SUMMARY_SET: {
            const { summary } = action.payload;
            const { altAssets } = state;
            return { ...state, altAssets: { ...altAssets, ...summary } };
        }
        case actionTypes.AUDIT_REVIEW_AUDIT_ASSETS_FILTER_SET: {
            const { filter, status } = action.payload;
            const { auditAssets } = state;
            return {
                ...state,
                auditAssets: { ...auditAssets, ...filter },
                status
            };
        }
        case actionTypes.AUDIT_REVIEW_AUDIT_ASSETS_SUMMARY_SET: {
            const { summary } = action.payload;
            const { auditAssets } = state;
            return { ...state, auditAssets: { ...auditAssets, ...summary } };
        }
        case actionTypes.AUDIT_REVIEW_VALIDATED_VISIBILITY_ASSETS_FILTER_SET: {
            const { filter, status } = action.payload;
            const { validatedVisibility } = state;
            return {
                ...state,
                validatedVisibility: { ...validatedVisibility, ...filter },
                status
            };
        }
        case actionTypes.AUDIT_REVIEW_VALIDATED_VISIBILITY_ASSETS_SUMMARY_SET: {
            const { summary } = action.payload;
            const { validatedVisibility } = state;
            return {
                ...state,
                validatedVisibility: { ...validatedVisibility, ...summary }
            };
        }
        case actionTypes.AUDIT_REVIEW_COMPLETION_SET: {
            const { isReissueNeeded, isReviewComplete } = action.payload;
            return { ...state, isReissueNeeded, isReviewComplete };
        }
        case actionTypes.AUDIT_REVIEW_INIT: {
            return { ...initialState };
        }
        case actionTypes.AUDIT_REVIEW_STATUS_SET: {
            const status = action.payload?.status ?? action.payload; //fallback to payload if payload.status is undefined
            return { ...state, status };
        }
        default: {
            return state;
        }
    }
}
